<script setup lang="ts">
defineProps<{
  data: CallToActionFragment[]
}>()

const handleExternalLink = (button: CallToActionFragment) => {
  if (!button.pageLink && !button.externalLink) {
    console.warn(`No link provided for "${button.title}" call to action`, button)
    return undefined
  } else if (button.pageLink && button.externalLink?.startsWith('#')) {
    return {
      path: usePathByType(button.pageLink?._modelApiKey, button.pageLink?.slug as string),
      hash: button.externalLink
    }
  } else if (button.externalLink?.startsWith('?')) {
    return (
      usePathByType(button.pageLink?._modelApiKey, button.pageLink?.slug as string) +
      button.externalLink
    )
  } else if (button.externalLink?.startsWith('http')) {
    return button.externalLink
  } else if (button.pageLink) {
    return usePathByType(button.pageLink?._modelApiKey, button.pageLink?.slug as string)
  }
}
</script>

<template>
  <div class="flex w-fit gap-4">
    <div v-for="(button, idx) in data" :key="idx">
      <Button
        :label="button.title && button.title"
        :to="handleExternalLink(button)"
        :target="button.externalLink?.startsWith('http') ? '_blank' : undefined"
        :variant="button.primary ? 'cta' : 'solid'"
      />
    </div>
  </div>
</template>
